import { useMutation } from '@tanstack/react-query';
import { csvErrorsFromRequestError, PriceListCsvError } from '../errors';
import { usePriceListsApi } from './use-price-lists-api';

export function useBulkUploadCsv() {
  const { priceListsApi } = usePriceListsApi();

  async function bulkUploadCsv(file: File) {
    try {
      await priceListsApi.bulkUploadCsv(await file.text());
    } catch (err) {
      throw new PriceListCsvError(csvErrorsFromRequestError(err));
    }
  }

  return useMutation({
    mutationFn: bulkUploadCsv,
  });
}
